// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import DashboardAdmin from "./pages/DashboardAdmin";
import DashboardGerente from "./pages/DashboardGerente";
import DashboardEmpleado from "./pages/DashboardEmpleado";
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />

        <Route
          path="/dashboard/administrador"
          element={
            <ProtectedRoute allow={["Administrador"]}>
              <DashboardAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/gerente"
          element={
            <ProtectedRoute allow={["Administrador", "Gerente"]}>
              <DashboardGerente />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/empleado"
          element={
            <ProtectedRoute allow={["Administrador", "Gerente", "Empleado"]}>
              <DashboardEmpleado />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
